import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from "../../../../../../../core/service/v2/dataservice/abstractDataServiceV2";
import {PaymentRequestConfigurationModel} from "../../../api/entity/paymentRequestConfiguration.model";
import {PaymentRequestConfigurationConverter} from "../../../api/entity/converter/paymentRequestConfiguration.converter";
import {CustomizeHttpUrlGenerator} from "../../../../../../../../store/core/url/customizeHttpUrlGenerator";

@Injectable()
export class PaymentRequestConfigurationDataService extends AbstractDataServiceV2<PaymentRequestConfigurationModel, PaymentRequestConfigurationConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig, converter: PaymentRequestConfigurationConverter) {
        super('PaymentRequestConfiguration', http, httpUrlGenerator, logger, config, converter);
    }
}
